import type { Board } from "../board";
import { CollectableItem, type CollectablePickupResult } from "../collectableItem";
import { Event } from "../events/event";
import { EventParameter } from "../events/eventParameter";
import { EventType } from "../events/eventType";
import type { Player } from "../player";

export class BaseKeyCard extends CollectableItem {
	static key = "BaseKeyCard";

	pickupBy(player: Player, board: Board): CollectablePickupResult {
		player.inventory.addItem(this);
		board.stats.recordItemCollected(BaseKeyCard.key, this.count);

		const event = new Event(EventType.GOT_ITEM);
		event.setParameter(EventParameter.AMMO_AMOUNT, String(this.count));
		event.setParameter(EventParameter.AMMO_NAME, this.getNameKey());
		board.addEvent(event);

		return { pickupKey: BaseKeyCard.key, amount: this.count, isInfinite: false };
	}

	static deserialize(data: any): BaseKeyCard {
		return new BaseKeyCard(data.count);
	}
}
